module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-TRIAL1-if-one-correct.8e96016b.mp3";